import { Color } from "./colors.js";
const assessmentScoreCategories = [
  {
    roundedScore: 5,
    color: Color.Green,
    label: "Excellent"
  },
  {
    roundedScore: 4,
    color: Color.Lime,
    label: "Good"
  },
  {
    roundedScore: 3,
    color: Color.Gray,
    label: "Acceptable"
  },
  {
    roundedScore: 2,
    color: Color.Yellow,
    label: "Poor"
  },
  {
    roundedScore: 1,
    color: Color.Red,
    label: "Very Poor"
  }
];
const fallbackAssessmentScoreCategory = {
  roundedScore: NaN,
  color: Color.Gray,
  label: "Unknown"
};
function getAssessmentScoreCategory(score) {
  const roundedScore = Math.round(score);
  return assessmentScoreCategories.find((c) => roundedScore === c.roundedScore) ?? fallbackAssessmentScoreCategory;
}
function getAssessmentScoreColor(score) {
  return getAssessmentScoreCategory(score).color;
}
function getAssessmentScoreLabel(score) {
  return getAssessmentScoreCategory(score).label;
}
export {
  getAssessmentScoreCategory,
  getAssessmentScoreColor,
  getAssessmentScoreLabel
};
//# sourceMappingURL=assessmentScore.js.map
